import {
  type BrainSignalTemplate,
  findBrainSignalTemplate,
} from '@this+that/models';
import type { TFunction } from 'i18next';

import type { BrainSignalSemanticInput } from '../../../../../../../../models/brainSignals';

export interface ResolvedSignalTemplateTexts {
  name: string;
  description: string;
  semantic: BrainSignalSemanticInput;
}

export function resolveSignalTemplateTexts(
  t: TFunction,
  template: BrainSignalTemplate,
): ResolvedSignalTemplateTexts {
  const { conditionKey, levelKeys, depth } = template.semantic;
  return {
    name: t(template.nameKey),
    description: t(template.descriptionKey),
    semantic: {
      condition: t(conditionKey),
      depth,
      levels: levelKeys.map(({ level, descriptionKey }) => ({
        level,
        description: t(descriptionKey),
      })),
    },
  };
}

export function buildSignalTemplateTexts(
  t: TFunction,
  templateId: string,
): ResolvedSignalTemplateTexts | undefined {
  const template = findBrainSignalTemplate(templateId);
  return template ? resolveSignalTemplateTexts(t, template) : undefined;
}
